import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import qs from 'query-string';

import { queryStringifyOptions } from 'utils/constants';

import InProgressSection from '../admin-servicers/InProgressSection';
import CompletedSection from '../admin-servicers/CompletedSection';
import { DashboardTemplate } from 'containers/dashboard/common-components';
import ProviderActionsToTake from './ProviderActionsToTake';

const ProviderDashboard = () => {
    const history = useHistory();

    const handleInfoCardFilter = useCallback(
        (payload, listType) => () => {
            history.push({
                pathname: `/${listType}`,
                search: `?${qs.stringify(payload, queryStringifyOptions)}`,
            });
        },
        [history]
    );

    return (
        <DashboardTemplate>
            <ProviderActionsToTake onListFilter={handleInfoCardFilter} />
            <InProgressSection onListFilter={handleInfoCardFilter} userIsProvider />
            <CompletedSection onListFilter={handleInfoCardFilter} userIsProvider />
        </DashboardTemplate>
    );
};

export default ProviderDashboard;
